import React from 'react';
// import css from './css.less';
import CustomInfomation from '../../Components/CustomInformation/CustomInformation';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCustomInfomationItems,
  setCustomInfomationItemsAddNew,
} from '../slice';
const productSetCustomInfo = (props) => {
  const customsInformationItems = useSelector(
    (state: any) => state.productSet.customsInformationItems,
  );
  const countries = useSelector((state: any) => state.productSet.countries);
  const dispatch = useDispatch();
  const customInformationItemsOnChange = (isDelete, index, settings) => {
    dispatch(
      setCustomInfomationItems({
        isDelete,
        index,
        settings,
      }),
    );
  };

  const customInformationItemsOnAdd = () => {
    dispatch(setCustomInfomationItemsAddNew());
  };
  return (
    <CustomInfomation
      disabled={props.disabled}
      items={customsInformationItems}
      countries={countries}
      customInformationItemsOnChange={customInformationItemsOnChange}
      customInformationItemsOnAdd={customInformationItemsOnAdd}
    />
  );
};
export default productSetCustomInfo;
